import CurrentPlanTag from '../../../components/common/badges/CurrentPlanTag';
import { CurrentTrialBadge } from '../../../components/common/badges/CurrentTrialBadge';
import { RecommendedBadge } from '../../../components/common/badges/RecommendedBadge';
import { useCardBadge } from '../../hooks/badges/useCardBadge';
import { isValidApiName } from '../../utils/typeguards';
import { jsx as _jsx } from "react/jsx-runtime";
export const BaseCardBadge = ({
  apiName,
  badgeName: providedBadgeName
}) => {
  const {
    badgeName: badgeNameToShow,
    validatedBundleKey,
    loading
  } = useCardBadge({
    apiName: isValidApiName(apiName) ? apiName : undefined,
    badgeName: providedBadgeName
  });
  if (!badgeNameToShow || loading) {
    return null;
  }

  // These components handle the trellis vs canvas logic internally
  switch (badgeNameToShow) {
    case 'CURRENT_PLAN':
      return /*#__PURE__*/_jsx(CurrentPlanTag, {
        message: "pricing-pages-ui.merchCardsV2.badges.CURRENT_PLAN"
      });
    case 'MOST_POPULAR':
    case 'RECOMMENDED':
      return /*#__PURE__*/_jsx(RecommendedBadge, {
        badgeName: badgeNameToShow
      });
    case 'OWNED_VIA_BUNDLE':
      return /*#__PURE__*/_jsx(CurrentPlanTag, {
        message: validatedBundleKey !== null && validatedBundleKey !== void 0 ? validatedBundleKey : ''
      });
    case 'LEGACY_OWNED':
      return /*#__PURE__*/_jsx(CurrentPlanTag, {
        message: "pricing-pages-ui.merchCardsV2.badges.LEGACY_OWNED"
      });
    case 'CURRENT_TRIAL':
      return /*#__PURE__*/_jsx(CurrentTrialBadge, {
        message: "pricing-pages-ui.merchCardsV2.badges.CURRENT_TRIAL"
      });
    default:
      return null;
  }
};